import { render } from "./ChipsSelector.vue?vue&type=template&id=1e85f777&scoped=true"
import script from "./ChipsSelector.vue?vue&type=script&lang=js"
export * from "./ChipsSelector.vue?vue&type=script&lang=js"

import "./ChipsSelector.vue?vue&type=style&index=0&id=1e85f777&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e85f777"]])

export default __exports__